import React, { useState, useContext, useEffect } from "react";
import { Divider,Button, Input, Typography, Modal, message, Spin, Switch, Tooltip  } from "antd"; // Import Spin for loading indicator
import { TeamOutlined, PlusOutlined, LoadingOutlined } from "@ant-design/icons"; // Import LoadingOutlined
import { SketchPicker } from "react-color"; // 🎨 Color Picker
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/authContext";
import axios from "axios";
import {unloadUnityWebGL, unityContext} from "../context/unityContext";

const { Title, Text } = Typography;

const RaumControls = ({sessionID}) => {
  const { currentUser } = useContext(AuthContext);
  const [isOwner, setIsOwner] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state

  const navigate = useNavigate();

  /* useEffect(() => {
    const fetchGroups = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await axios.get(`/api/groups/owner/${currentUser.id}`);
        setGroups(response.data);
        setIsMember(response.data.length > 0);
      } catch (error) {
        console.error("Error fetching groups:", error);
        message.error("Beim Abrufen der Gruppen ist ein Fehler aufgetreten.");
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };
    fetchGroups();
  }, [currentUser.id]);*/

  useEffect(() => {

    if (unityContext) unloadUnityWebGL();
    const fetchGroups = async () => {
      setLoading(true);
      try {
        let response;
        if (currentUser.role === 0) {
          // Admin fetches owned groups
          setIsOwner(true);
          console.log("admin get group");
          response = await axios.get(`/api/groups/owner/${currentUser.id}`);
        } else {
          // Normal users fetch groups they belong to
          console.log("normal user get group");
          response = await axios.get(`/api/groups/member/${currentUser.id}`);
        }
        setGroups(response.data);
      } catch (error) {
        console.error("Error fetching groups:", error);
        message.error("Beim Abrufen der Gruppen ist ein Fehler aufgetreten.");
      } finally {
        setLoading(false);
      }
    };
    fetchGroups();
  }, [currentUser.id, currentUser.role]);


  

  // Custom loading indicator
  const loadingIndicator = (
    <LoadingOutlined style={{ fontSize: 24, color: "#FFD700" }} spin />
  );

  const [canControlDMC, setCanControlDMC] = useState({});

  useEffect(() => {
    const fetchRaumPermissions = async () => {
      try {
        const response = await axios.get("/api/groups/raum-dmc"); // Fetch all groups
        const permissions = {};
  
        response.data.forEach((group) => {
          permissions[group.id] = group.sid_dmc !== null; // Ensure it's a boolean
        });
        console.log("Fetched Raumpermissions:", permissions);
        setCanControlDMC(permissions); // Update state with all permissions
      } catch (error) {
        console.error("Error fetching raum permissions:", error);
      }
    };
  
    if (groups.length > 0) {
      fetchRaumPermissions();
    }
  }, [groups]);

  const handleCanControlDMCToggle = async (groupId, canControl) => {
    try {
      const url = canControl
        ? `/api/groups/${groupId}/grant-raum`
        : `/api/groups/${groupId}/revoke-raum`;
  
      await axios.put(url, {
        sessionId: sessionID
      }); // Update permission in DB
  
      // Update local state to reflect the change immediately
      setCanControlDMC((prev) => ({
        ...prev,
        [groupId]: canControl,
      }));
  
      message.success(
        canControl
          ? "Die Gruppenmitglieder befinden sich nun in der Sitzung."
          : "Die Gruppenmitglieder haben die Sitzung nun verlassen."
      );
    } catch (error) {
      console.error("Error updating room permission:", error);
      message.error("Fehler beim Aktualisieren der Raumberechtigungen.");
    }
  };
  

  return (
    <div style={{ padding: "24px", textAlign: "left" }}>
      {/* Title Section */}
      
      
      <h1>{isOwner}</h1>
      {/* Show "Create Group" button only for admins */}
      

      {loading ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <Spin indicator={loadingIndicator} size="large" />
        </div>
      ) : (
        <>
          {/* No Groups Message */}
          {groups.length === 0 && (
            <div style={{ textAlign: "left", marginTop: "40px" }}>
              <TeamOutlined
                style={{
                  fontSize: "64px",
                  color: "#FFD700",
                  display: "block",
                  marginBottom: "8px",
                }}
              />
              <Text style={{ fontSize: "16px", color: "#666" }}>
                {isOwner
                  ? "Du hast noch keine Gruppe erstellt."
                  : "Du bist noch kein Mitglied einer Gruppe."}
              </Text>
            </div>
          )}

          {/* Groups List */}
          {groups.length > 0 && (
            <div style={{ marginTop: "px" }}>
              {groups.map((group, index) => (
                <div
                  key={group.id}
                //   onClick={() => navigate(`/group/${group.id}`)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",
                  
                    borderRadius: "8px",
                    marginBottom: "4px",
                    cursor: "pointer",
                    transition: "background 0.3s",
                    border: `1px solid ${group.color || "#ddd"}`, 
                  }}
                >
                  {/* Colored Square with Number */}
                  <div
                    style={{
                      width: "60px",
                      height: "6vh",
                      backgroundColor: group.color || "#FFD700",
                      color: "#fff",
                      fontSize: "18px",
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "6px",
                      marginRight: "12px",
                    }}
                  >
                    {index + 1}
                  </div>

                  {/* Group Name */}
                  <Text style={{ fontSize: "16px", fontWeight: "500" }}>
                    {group.name}
                  </Text>

                  {/* Projection Control Toggle (Admins Only) */}
                  {isOwner && (
  <div
    onClick={(e) => e.stopPropagation()} 
    style={{
      marginLeft: "auto",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    }}
  >
   
    <Tooltip title="Dies ermöglicht es den Studierenden einer Gruppe, der erstellten Sitzung beizutreten.">

      <Switch
      checkedChildren="Gruppe zulassen" unCheckedChildren="Gruppe nicht erlaubt"
        checked={canControlDMC[group.id] || false}
        onChange={(checked) => handleCanControlDMCToggle(group.id, checked)}
      />
    </Tooltip>
  </div>
)}
                </div>
              ))}
            </div>
          )}
        </>
      )}

    </div>
  );
};

export default RaumControls;
